module.exports = __webpack_public_path__ + "img/oaks-nest-fluted-wall-1.1b5050b8.jpeg";